export const stateName = 'favouriteItems';